import $ from 'jquery';
import throttle from 'lodash/throttle';
import visible from './visible.js';
import Splide from '@splidejs/splide';
import fitvids from 'fitvids'; 

/**
 * Mobile navigation toggle
 * @param  {mixed} event
 */

const toggleMenu = (event) => {
    event.preventDefault();
    $('.header__navigation').fadeToggle();
    $('.js-menu-toggle, .nav--header').toggleClass('open');
    $('.header').toggleClass('menu-open');
};

$('.js-menu-toggle').on('click', toggleMenu);


// Scroll to next section

$('.events__scroll').on('click', function(e) {
    e.preventDefault();
    $('html, body').animate({
        scrollTop: $('.section').nextAll('.section').offset().top - 86
    }, 1000);
});

// Header animation on load

$(window).on('load', function() {
    setTimeout(function() {
        $('.header').addClass('loaded');
        setTimeout(function() {
            $('section .container').addClass('loaded');
            $('.section').first().addClass('loaded');
        }, 400)
    }, 300)
});

// Footer animation on scroll

$(window).on('load scroll', throttle(() => {
    if($('.footer, .section').visible(true)) {
      $('.footer, .section').addClass('loaded');
    }
}, 300));


// Row animation on scroll

$(window).on('load scroll', throttle(() => {
    if($('.archive__header, .archive__post').visible(true)) {
      $('.archive__header, .archive__post').addClass('loaded');
    }
}, 300));


// On Scroll: Animate visible items

const $modules = $('.item--animate, .row--flex--items, .footer');

$(window).on('load scroll', throttle(() => {
  $modules.each((index, item) => {
    const $el = $(item);
    if($el.visible(true)) {
      $el.addClass('item--visible');
    }
  });
}, 300));


// Splide

document.addEventListener('DOMContentLoaded', function () {

    if ( $('#gallery').length )
    {
        var gallery = new Splide( '#gallery', {
            type: 'loop',
            // fixedWidth: '340px', 
            gap: '48px',
            perPage: 1,
            perMove: 1,
            clones: 3,
            arrows: false,
            pagination: false,
            breakpoints: {
                1150: {
                    gap: '24px',
                    perPage: 1.1,
                },
                600: {
                    gap: '12px',
                    perPage: 1.05,
                },
            }
        }).mount(); 
    }     

    $('.splide__arrow.splide__arrow--next').on('click', function(e) {
        e.preventDefault();
        gallery.go(gallery.index + 1);
    }); 

    $('.splide__arrow.splide__arrow--prev').on('click', function(e) {
        e.preventDefault();
        gallery.go(gallery.index - 1);
    }); 

}); 





// Play overlay

$('.video__overlay').on('click', function() {
    $(this).fadeOut();
    $(this).siblings('video').get(0).play()
});

$('video').on('click', function() {
    $(this).get(0).pause();
    $(this).siblings('.video__overlay').fadeIn();
});


var iframe = document.querySelector('.video-audio__video iframe');

if ( iframe) 
{
    fitvids({
        players: 'iframe[src*="example.com"]'
    })
}

/**
 * WPML language switcher
 */

$(window).on('load', function() {

   var current_lang = $('.current-lang').data('lang');
   var origin = window.location.origin;
   var pathname = window.location.pathname;
   
   if ( current_lang != 'en' )
   {
      var url = origin + '/en' + pathname;
   }
   else
   {
      var url = origin + pathname.replace('/en', '');
   }

   $('.change-language a').attr("href", url);

});

// $('.language-switcher a').on('click', function(e) {

//     e.preventDefault();
//     var current_lang = $(this).data('lang');
//     var origin = window.location.origin;
//     var pathname = window.location.pathname;
   
//     if ( current_lang == 'fr' )
//     {
//         var url = origin + pathname.replace('/en', '');
//         window.location = url;
//     }
//     else
//     {
//         var url = origin + pathname;
//         window.location = url;
//     }

// });